import { useApiQuery } from '../../../../common/infrastructure/hooks/useApiQuery';
import { endpointsMetadata } from '../../../../common/infrastructure/routes/endpointsMetadata';
import { IGroupClassFamilyMember } from '../models';

/**
 * Hook to fetch family members with their reservation status for a specific event
 * Shows which members already have reservations to prevent double-booking
 */
export const useGroupClassFamilyMembersWithStatus = (
  studioId: number | undefined,
  eventId: number | undefined,
  enabled: boolean = true
) => {
  const { data, isLoading, error } = useApiQuery<IGroupClassFamilyMember[]>({
    queryKey: [endpointsMetadata.groupClasses.getFamilyMembersWithStatus, studioId, eventId],
    endpoint: `${endpointsMetadata.groupClasses.getFamilyMembersWithStatus}?eventId=${eventId}`,
    enabled: !!studioId && !!eventId && enabled,
    globalIsLoading: false,
  });

  return {
    familyMembers: data ?? [],
    isLoading,
    error,
    hasData: !!data && data.length > 0,
    hasFamilyMembers: !!data && data.length > 1, // More than 1 means user has family members to select
  };
};
